import { useMemo } from "react";
import { matchesQuery } from "tm-shared/utils";

export function useQueryFilter<T>(
    items: T[],
    query: string,
    pickers: readonly ((item: T) => string | number | undefined | null)[],
): T[] {
    return useMemo(() => {
        const q = query.trim().toLowerCase();

        if (!q) return items;

        return items.filter((item) => matchesQuery(item, query, pickers));
    }, [items, query, pickers]);
}
